import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StateBorderList } from './state-border-list';
import { environment } from '../../../environments/environment';
import { StateProvinceService } from '../state-province/state-province.service';

@Injectable()
export class BorderConnectionService {
  stateList:StateBorderList[]=[];
  fuelList:string[];
  finishedList:string[];

  constructor(private http: HttpClient, private stateProvinceService: StateProvinceService) {
    this.stateProvinceService.getStateBorderList()
      .toPromise()
      .then((data: any) => {
      data.forEach(s => {
        const st = {
          name: s["state"],
          borderList: s["borderingStates"].split(',')
        }
        this.stateList.push(st)
      });
    });
  }

  checkValidPath(listOfStates){
    this.finishedList=[];
    this.fuelList = listOfStates.filter((v, i, a) => a.indexOf(v) === i);
    this.fillState(this.fuelList[0]);
    return [this.fuelList, this.finishedList];
  }

  fillState(state:string){
    this.finishedList.push(state);
    const index = this.fuelList.indexOf(state);
    if (index !== -1) {
      this.fuelList.splice(index, 1);
    }
    if(this.stateList.find(i => i.name == state)){
      this.stateList.find(i => i.name == state).borderList.forEach(s => {
        if(this.fuelList.includes(s)){
          this.fillState(s);
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/border/border-connection.service.ts